import React from 'react'
import ClosurePanel from 'modules/Admin/ClosurePanel'
import { useReadOnly } from 'utils/lifecycle'
import { useDispatch } from 'react-redux'
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableContainer
} from '@mui/material'
import BusinessPage from '../../components/BusinessPage'
import * as uiActions from 'modules/UI/actions'
import Definition from './components/Definition'
import Keywords from './components/Keywords'
import BusinessBudget from './components/BusinessBudget'
import Owner from './components/Owner'
import BusinessAddresses from './components/BusinessAddresses'
import { useIsMobile } from 'utils/UI'

// ---------------- Phone Formatting ----------------
const formatPhone = (input = "") => {
  const digits = input.replace(/\D/g, "").slice(0, 10);
  if (!digits) return "";
  let formatted = "";
  if (digits.length < 4) formatted = `(${digits}`;
  else if (digits.length < 7) formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  else formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  return formatted;
};

const fulfillmentLabels = {
  RETAIL: 'Retail',
  SERVICE: 'Service',
  RETAIL_AND_SERVICE: 'Retail and service',
}

const Info = ({ business }) => {
  const readOnly = useReadOnly()
  const dispatch = useDispatch()
  const isMobile = useIsMobile()

  const companyInfo =
    business && business.companyInfo ? business.companyInfo : {}

  return (
    <BusinessPage title={isMobile ? 'Business' : 'Business profile'}>
      <Box p={2}>
        <fieldset disabled={readOnly} style={{ border: 0, padding: 0, margin: 0 }}>
        <Button disabled={readOnly} color="primary" variant="contained" onClick={() => dispatch(uiActions.showBusinessForm(true))}>
          Edit details
        </Button>
        <Box my={3}>
          <Grid container spacing={2}>
            <Grid item sm={12} md={8} lg={6}>
              <Card>
                <CardHeader subheader="Business details" />
                <CardContent>
                  <Box display="flex" alignItems="center">
                    <Box p={2}>
                    {/* {console.log("Company Logo URL:", companyInfo.logoUrl)} */}
                      <img src={companyInfo.logoUrl} height={50} alt="logo" />
                    </Box>
                  </Box>
                  <TableContainer>
                    <Table>
                      <TableBody>
                        <Definition id="Business" value={companyInfo.companyName} />
                        <Definition id="Street" value={companyInfo.street} />
                        {companyInfo.addressLine2 ? (
                          <Definition id="Suite / apt" value={companyInfo.addressLine2} />
                        ) : null}
                        <Definition id="City" value={companyInfo.city} />
                        <Definition id="State / region" value={companyInfo.state || '—'} />
                        <Definition id="Postal code" value={companyInfo.zipCode} />
                        <Definition
                          id="Country"
                          value={companyInfo.countryName || companyInfo.countryCode || 'US'}
                        />
                        <Definition id="Phone" value={companyInfo.phoneNumber ? formatPhone(companyInfo.phoneNumber) : ''} />
                        <Definition id="Site url" value={companyInfo.siteUrl} />
                        <Definition id="Categories" value={business.categories.map(c => c.name).join(', ')} />
                        <Definition
                          id="Fulfillment"
                          value={fulfillmentLabels[companyInfo.fulfillment] || 'Not selected'}
                        />
                        {/* <Definition id="Categories" value={business.categories.map(c => c.categoryName).join(', ')} />                       */}

                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
              <Owner />
            </Grid>
            <Grid item sm={12} md={4} lg={6}>
  <Box mb={2}>
    <BusinessBudget />
  </Box>
  <Box mb={2}>
    <Keywords />
  </Box>
  <Box mb={2}>
    <BusinessAddresses />
  </Box>
</Grid>

          </Grid>
        </Box>
      </fieldset>
      </Box>
      <ClosurePanel businessId={business.businessId} />
    </BusinessPage>
  )
}

export default Info
